/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import HotelOptionState from './state/HotelOptionState'
import UserEvent from '../../event/UserEvent'
import SelectOptionEvent from '../../event/SelectOptionEvent'

class HotelOptionsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List([])
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case SelectOptionEvent.fetchHotels:
      case UserEvent.fetchUserHotels:
        const hotels = payload.hotels.map(hotel => {
          return new HotelOptionState().mergeModel(hotel)
        })
        return List(hotels)

      default:
        return state
    }
  }
}

export default new HotelOptionsStore()
